export default function Logo({ isMobile }) {
  return (
    <img
      src="logo.webp"
      alt="logo"
      className={`max-h-20 h-auto w-auto object-contain rounded-md ${
        isMobile ? "relative left-20" : ""
      }`}
    />
  );
}
